import { atom, } from 'recoil';
const ToastMessageAtom = atom({
    key: 'toastMessage', // unique ID (with respect to other atoms/selectors)
    default: '', // default value (aka initial value)
});

export default ToastMessageAtom;